__turbopack_context__.v({
  "slider": "LQf5ra_slider",
});
